<template>
    <div>
        {{ tr.formSavedEmailLink }}<br>
        <copy-text class="link" :label="`${tr.formLink}:`" :text="link"/>
        {{ tr.mayCloseOrContinue }}
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import CopyText from '../CopyText';

    export default {
        data() {
            return {};
        },
        components: {CopyText},
        computed: {
            ...mapGetters({
                link: 'package/link',
                tr: 'lang/tr',
            }),
        },
    }
</script>

<style lang="scss" scoped>
    .link {
        margin: 1em 0 2em;
    }
</style>